import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { faqItems } from '@/mocks/comics';

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫画网',
  url: 'http://ipv6c.com/',
  description: '韩漫画网设有免费漫画弹窗入口，作为海量正版漫画在线阅读平台，内容安全可靠，让您安心享受高质量漫画资源。',
  sameAs: ['http://ipv6c.com/'],
};

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫画网',
  url: 'http://ipv6c.com/',
  description: '海量正版漫画在线阅读平台',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://ipv6c.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const jsonLdWebPage = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫画网 - 免费漫画弹窗入口 - 海量正版漫画在线阅读平台',
  description: '韩漫画网设有免费漫画弹窗入口，作为海量正版漫画在线阅读平台，内容安全可靠，让您安心享受高质量漫画资源。',
  url: 'http://ipv6c.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫画网',
    url: 'http://ipv6c.com/',
  },
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrganization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebSite) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebPage) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFAQ) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedGrid />
        <LatestUpdates />
        <CTASection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}